if (!customElements.get('inline-cta') && !customElements.get('fixed-cta')) {
  class InlineCTA extends HTMLElement {
    constructor() {
      super();
      
      const button = this.querySelector('[data-cta-btn]');
      if (!button) return;

      const target = button.dataset.target;
      this.targetEl = document.querySelector(target);

      if (this.targetEl) {
        button.addEventListener('click', this.handleClick.bind(this));
      }
    }

    handleClick(event) {
      event.preventDefault();

      const offset = 120;
      const elementPosition = this.targetEl.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.scrollY - offset;

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  }

  customElements.define('inline-cta', InlineCTA);

  class FixedCTA extends InlineCTA {
    constructor() {
      super();

      if (this.targetEl) {
        this.watchTargetVisibility();
      }
    }

    watchTargetVisibility() {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (!entry.isIntersecting && entry.boundingClientRect.top < 0) {
            this.classList.add('visible');
          } else {
            this.classList.remove('visible');
          }
        });
      }, { threshold: 0 });

      observer.observe(this.targetEl);
    }
  }

  customElements.define('fixed-cta', FixedCTA);
}